import CLIENT from '../actionTypes';

import { AppAction } from '../../../types/app';
import { ClientRecoveryPasswordState } from '../types';

const initialState: ClientRecoveryPasswordState = {
  sendCodeReadyStatus: CLIENT.RECOVERY_PASSWORD.SEND_CODE.INVALID,
  changePasswordReadyStatus: CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.INVALID,
  sessionId: null,
  email: null,
  passwordType: null,
  err: null,
};

export default (
  state: ClientRecoveryPasswordState = initialState,
  action: AppAction = {}
): ClientRecoveryPasswordState => {
  switch (action.type) {
    case CLIENT.RECOVERY_PASSWORD.SEND_CODE.INVALID:
    case CLIENT.RECOVERY_PASSWORD.SEND_CODE.REQUESTING:
      return {
        ...state,
        sendCodeReadyStatus: action.type,
        changePasswordReadyStatus:
          CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.INVALID,
        err: null,
        sessionId: null,
        email: null,
        passwordType: null,
      };
    case CLIENT.RECOVERY_PASSWORD.SEND_CODE.FAILURE:
      return {
        ...state,
        sendCodeReadyStatus: action.type,
        err: action.err,
      };
    case CLIENT.RECOVERY_PASSWORD.SEND_CODE.SUCCESS:
      return {
        ...state,
        sendCodeReadyStatus: action.type,
        err: null,
        sessionId: action.sessionId,
        email: action.email,
        passwordType: action.passwordType,
      };
    case CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.REQUESTING:
      return {
        ...state,
        changePasswordReadyStatus: action.type,
        err: null,
      };
    case CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.FAILURE:
      return {
        ...state,
        changePasswordReadyStatus: action.type,
        err: action.err,
      };
    case CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.SUCCESS:
      return {
        ...state,
        changePasswordReadyStatus: action.type,
        err: null,
        sessionId: null,
        email: null,
        passwordType: null,
      };
    default:
      return state;
  }
};
